import { multi, withDependencies, optional, named } from '@wix/thunderbolt-ioc'
import type {
	IPageWillMountHandler,
	ServiceProvider,
	IPropsStore,
	IStructureAPI,
	Experiments,
	IPageServicesRegistrar } from '@wix/thunderbolt-symbols'
import {
	SiteServicesManagerSymbol,
	ServiceProviderSymbol,
	Props,
	StructureAPI,
	SignalsPageServiceProviderSymbol,
	contextIdSymbol,
	ExperimentsSymbol,
	PageFeatureConfigSymbol,
	pageIdSym,
} from '@wix/thunderbolt-symbols'
import { createServicesManager, createServicesMap } from '@wix/services-manager'
import type { ServiceRegistrarPageConfig } from './types'
import { name } from './symbols'
import { getNoopServices } from './noopServices'
import type { ServicesManager } from '@wix/services-manager/types'

export const PageServiceManager = withDependencies<IPageWillMountHandler>(
	[
		multi(ServiceProviderSymbol),
		SignalsPageServiceProviderSymbol,
		StructureAPI,
		Props,
		ExperimentsSymbol,
		pageIdSym,
		optional(SiteServicesManagerSymbol),
	],
	(
		pageServiceProviders: Array<ServiceProvider>,
		signalsServiceProvider: ServiceProvider,
		structureAPI: IStructureAPI,
		propsStore: IPropsStore,
		experiments: Experiments,
		pageId: string,
		siteServicesManager?: ServicesManager,
	): IPageWillMountHandler & IPageServicesRegistrar => {
		const additionalServices = [signalsServiceProvider]
		const services = [...pageServiceProviders, ...additionalServices, ...getNoopServices()]
		const servicesManager = createServicesManager(createServicesMap(services), siteServicesManager)
		const isServicesInfraOpen = !!experiments['specs.thunderbolt.servicesInfra']

		return {
			name: 'pageServiceManagerPageWillMount',
			pageWillMount() {
				if (isServicesInfraOpen) {
					const wrapperId =
						pageId === 'masterPage' ? 'masterPage' : structureAPI.getPageWrapperComponentId(pageId, pageId)
					propsStore.update({ [wrapperId]: { servicesManager } })
				}
			},
			get: () => servicesManager,
		}
	}
)

export const PageServiceManagerDs = withDependencies<IPageWillMountHandler>(
	[
		named(PageFeatureConfigSymbol, name),
		multi(ServiceProviderSymbol),
		SignalsPageServiceProviderSymbol,
		StructureAPI,
		Props,
		contextIdSymbol,
		ExperimentsSymbol,
		optional(SiteServicesManagerSymbol),
	],
	(
		{ isPopup }: ServiceRegistrarPageConfig,
		pageServiceProviders: Array<ServiceProvider>,
		signalsServiceProvider: ServiceProvider,
		structureAPI: IStructureAPI,
		propsStore: IPropsStore,
		contextId: string,
		experiments: Experiments,
		siteServicesManager?: ServicesManager,
	): IPageWillMountHandler & IPageServicesRegistrar => {
		const isServicesInfraOpen = !!experiments['specs.thunderbolt.servicesInfra']
		if (!isServicesInfraOpen) {
			return {
				name: 'pageServiceManagerPageWillMount',
				pageWillMount() {},
				get: () => createServicesManager(createServicesMap([])),
			}
		}
		const additionalServices = [signalsServiceProvider]

		const services = [...additionalServices, ...pageServiceProviders, ...getNoopServices()]
		const servicesManager = createServicesManager(createServicesMap(services), siteServicesManager)

		return {
			name: 'pageServiceManagerPageWillMount',
			pageWillMount(pageId: string) {
				if (isServicesInfraOpen) {
					if (pageId === 'masterPage') {
						propsStore.update({ masterPage: { servicesManager } })
					} else {
						const wrapperId = isPopup ? structureAPI.getPageWrapperComponentId(pageId, pageId) : contextId
						propsStore.update({ [wrapperId]: { servicesManager } })
					}
				}
			},
			get: () => servicesManager,
		}
	}
)
